import React, { Suspense } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { DetalheClientCredentials } from '../pages/client-credentials/DetalheClientCredentials';
import { DetalheEquipes } from '../pages/c4-model/equipes/DetalheEquipes';
import { ListagemEquipes } from '../pages/c4-model/equipes/ListagemEquipes';
import { ListagemUsuarios } from '../pages/c4-model/usuarios/ListagemUsuarios';
import { DetalheUsuarios } from '../pages/c4-model/usuarios/DetalheUsuarios';
import { ListagemSistemas } from '../pages/c4-model/sistemas/ListagemSistemas';
import { DetalheSistemas } from '../pages/c4-model/sistemas/DetalheSistemas';
import { Diagramas } from '../pages/c4-model/diagramas/Diagramas';
import { ListageDatamDataFactory } from '../pages/data-factory/ListagemDataFactory';
import { DetalhesDataFactory } from '../pages/data-factory/DetalhesDataFactory';

const SplashScreen = React.lazy(() =>
  import('../shared/components').then(({ SplashScreen }) => ({
    default: SplashScreen,
  }))
);

const ListagemLicenciamentosPage = React.lazy(() =>
  import('../pages/licenciamentos/ListagemLicenciamentosPages').then(
    ({ ListagemLicenciamentosPage }) => ({
      default: ListagemLicenciamentosPage,
    })
  )
);

const DetalheLicenciamentosPage = React.lazy(() =>
  import('../pages/licenciamentos/DetalheLicenciamentosPage').then(
    ({ DetalheLicenciamentosPage }) => ({
      default: DetalheLicenciamentosPage,
    })
  )
);

const ListagemTenantsPage = React.lazy(() =>
  import('../pages/tenants/ListagemTenantsPage').then(
    ({ ListagemTenantsPage }) => ({
      default: ListagemTenantsPage,
    })
  )
);

const TelemetriaGVCollegePage = React.lazy(() =>
  import('../pages/telemetria-gvcollege/TelemetriaGvCollegePage').then(
    ({ TelemetriaGvCollegePage }) => ({
      default: TelemetriaGvCollegePage,
    })
  )
);

const RedirecionamentoDeTopicosPage = React.lazy(() =>
  import('../pages/topic-manager/RedirecionamentoDeTopicosPage').then(
    ({ RedirecionamentoDeTopicosPage }) => ({
      default: RedirecionamentoDeTopicosPage,
    })
  )
);

const TopicosDeTenantsPage = React.lazy(() =>
  import('../pages/topic-manager/TopicosDeTenantsPage').then(
    ({ TopicosDeTenantsPage }) => ({
      default: TopicosDeTenantsPage,
    })
  )
);

const Dashboard = React.lazy(() =>
  import('../pages/dashboard/Dashboard').then(({ Dashboard }) => ({
    default: Dashboard,
  }))
);

const DetalheTenantsPage = React.lazy(() =>
  import('../pages/tenants/DetalheTenantsPage').then(
    ({ DetalheTenantsPage }) => ({
      default: DetalheTenantsPage,
    })
  )
);

const ConsultaProdutosHabilitados = React.lazy(() =>
  import(
    '../pages/tenants/components/consulta-produtos-habilitados/ConsultaProdutosHabilitados'
  ).then(({ ConsultaProdutosHabilitados }) => ({
    default: ConsultaProdutosHabilitados,
  }))
);

const ListagemProdutosPage = React.lazy(() =>
  import('../pages/produtos/ListagemProdutosPage').then(
    ({ ListagemProdutosPage }) => ({
      default: ListagemProdutosPage,
    })
  )
);

const DetalheProdutosPage = React.lazy(() =>
  import('../pages/produtos/DetalheProdutosPage').then(
    ({ DetalheProdutosPage }) => ({
      default: DetalheProdutosPage,
    })
  )
);

const ConsultaFeedbacks = React.lazy(() =>
  import('../pages/consulta-feedbacks/ConsultaFeedbacks').then(
    ({ ConsultaFeedbacks }) => ({
      default: ConsultaFeedbacks,
    })
  )
);

const DetalhesFeedback = React.lazy(() =>
  import('../pages/consulta-feedbacks/DetalhesFeedback').then(
    ({ DetalhesFeedback }) => ({
      default: DetalhesFeedback,
    })
  )
);

const ListagemDeRelatorios = React.lazy(() =>
  import('../pages/relatorios/ListagemDeRelatorios').then(
    ({ ListagemDeRelatorios }) => ({
      default: ListagemDeRelatorios,
    })
  )
);

const ExportarParaProducaoPage = React.lazy(() =>
  import('../pages/relatorios/ExportarParaProducaoPage').then(
    ({ ExportarParaProducaoPage }) => ({
      default: ExportarParaProducaoPage,
    })
  )
);

const TabsTelemetria = React.lazy(() =>
  import('../pages/telemetria/TabsTelemetria').then(({ TabsTelemetria }) => ({
    default: TabsTelemetria,
  }))
);

const ListagemTermosPage = React.lazy(() =>
  import('../pages/termos/ListagemTermosPage').then(
    ({ ListagemTermosPage }) => ({
      default: ListagemTermosPage,
    })
  )
);

const DetalheTermosPage = React.lazy(() =>
  import('../pages/termos/DetalheTermosPage').then(({ DetalheTermosPage }) => ({
    default: DetalheTermosPage,
  }))
);

const ListagemCategoriasPage = React.lazy(() =>
  import('../pages/termos/ListagemCategoriasPage').then(
    ({ ListagemCategoriasPage }) => ({
      default: ListagemCategoriasPage,
    })
  )
);

const DetalheCategoriasPage = React.lazy(() =>
  import('../pages/termos/DetalheCategoriasPage').then(
    ({ DetalheCategoriasPage }) => ({
      default: DetalheCategoriasPage,
    })
  )
);

const ListagemDeFuncoes = React.lazy(() =>
  import('../pages/relatorios/funcoes/ListagemDeFuncoes').then(
    ({ ListagemDeFuncoes }) => ({
      default: ListagemDeFuncoes,
    })
  )
);

const DetalheFuncoesPage = React.lazy(() =>
  import('../pages/relatorios/funcoes/DetalheFuncoesPage').then(
    ({ DetalheFuncoesPage }) => ({
      default: DetalheFuncoesPage,
    })
  )
);

// `${Environment.API_GATEWAY}/arquiteturac4model/api/v1/diagramas`,

// Utility route component that opens the external diagram URL in a new tab

export const AppRoutes: React.FC = () => {
  return (
    <Suspense fallback={<SplashScreen />}>
      <Routes>
        <Route path="/pagina-inicial" element={<Dashboard />} />
        <Route path={'/tenants'} element={<ListagemTenantsPage />} />
        <Route path={'/tenants/:page'} element={<ListagemTenantsPage />} />
        <Route path={'/tenants/detalhe/:id'} element={<DetalheTenantsPage />} />
        <Route
          path={'/tenants/:page/:busca'}
          element={<ListagemTenantsPage />}
        />

        <Route
          path={'tenants/consulta/:id'}
          element={<ConsultaProdutosHabilitados />}
        />

        <Route path={'/produtos'} element={<ListagemProdutosPage />} />
        <Route path={'/produtos/:page'} element={<ListagemProdutosPage />} />
        <Route
          path={'/produtos/detalhe/:id'}
          element={<DetalheProdutosPage />}
        />
        <Route
          path={'/produtos/:page/:busca'}
          element={<ListagemProdutosPage />}
        />
        <Route
          path={'/licenciamentos/detalhe/:id'}
          element={<DetalheLicenciamentosPage />}
        />
        <Route
          path={'/licenciamentos/:page/:busca'}
          element={<ListagemLicenciamentosPage />}
        />
        <Route
          path={'/licenciamentos'}
          element={<ListagemLicenciamentosPage />}
        />

        <Route
          path={'/telemetria-gvcollege'}
          element={<TelemetriaGVCollegePage />}
        />

        <Route path={'/consulta-feedbacks'} element={<ConsultaFeedbacks />} />
        <Route
          path={'/resultado-feedbacks-tenant/:idTenant'}
          element={<DetalhesFeedback />}
        />
        <Route
          path={'/resultado-feedbacks-produto/:idProduto'}
          element={<DetalhesFeedback />}
        />

        <Route path={'/relatorios'} element={<ListagemDeRelatorios />} />
        <Route
          path={'/exportar-producao'}
          element={<ExportarParaProducaoPage />}
        />

        {/* <Route path={'/consulta-telemetria'} element={<Telemetria />} /> */}
        <Route path={'/consulta-telemetria'} element={<TabsTelemetria />} />

        <Route path={'/termos-padrao'} element={<ListagemTermosPage />} />
        <Route
          path={'/termos-padrao/detalhe/:id'}
          element={<DetalheTermosPage />}
        />
        <Route
          path={'/categorias-de-termo'}
          element={<ListagemCategoriasPage />}
        />
        <Route
          path={'/categorias-de-termo/detalhe/:id'}
          element={<DetalheCategoriasPage />}
        />

        <Route path={'/funcoes'} element={<ListagemDeFuncoes />} />
        <Route path={'/funcoes/detalhe/:id'} element={<DetalheFuncoesPage />} />

        <Route
          path={'/redirecionamento-topicos'}
          element={<RedirecionamentoDeTopicosPage />}
        />

        <Route path={'/topicos-tenants'} element={<TopicosDeTenantsPage />} />

        <Route path={'/secrets'} element={<DetalheClientCredentials />} />

        <Route path={'/c4-equipes/detalhe/:id'} element={<DetalheEquipes />} />
        <Route path={'/c4-equipes'} element={<ListagemEquipes />} />
        <Route path={'/c4-usuarios'} element={<ListagemUsuarios />} />
        <Route
          path={'/c4-usuarios/detalhe/:id'}
          element={<DetalheUsuarios />}
        />
        <Route path={'/c4-sistemas'} element={<ListagemSistemas />} />
        <Route
          path={'/c4-sistemas/detalhe/:id'}
          element={<DetalheSistemas />}
        />

        <Route path={'/c4-diagramas'} element={<Diagramas />} />

        <Route path={'/gv-data-factory'} element={<ListageDatamDataFactory />} />
        <Route path={'/gv-data-factory/detalhe/:id'} element={<DetalhesDataFactory />} />
        {/* ROBO - Nova linha acima [rotas] */}

        <Route path="/" element={<Navigate to="/pagina-inicial" />} />
        <Route path="*" element={<Navigate to="/pagina-inicial" />} />
      </Routes>
    </Suspense>
  );
};
